var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { ethers } from 'ethers';
import { Keypair } from '@solana/web3.js';
import bs58 from 'bs58';
import { fetchIPFSData } from '../misc/fetchIPFSData';
import { slackLogger } from '@shared/utils/off-chain/slack-logger';
import { encrypt } from '@/hooks/auth/useGetWrappedWallet';
export function signatureToDecryptEncryptedWallet(_a) {
    return __awaiter(this, arguments, void 0, function (_b) {
        var startTime, messageToVerify_0, signature, signEcdsa, signResponse, e_1;
        var PKP = _b.PKP, litSession = _b.litSession, litNodeClient = _b.litNodeClient, litCachedMinSig = _b.litCachedMinSig, setLitCachedMinSig = _b.setLitCachedMinSig;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    startTime = Date.now();
                    _c.label = 1;
                case 1:
                    _c.trys.push([1, 5, , 7]);
                    messageToVerify_0 = 'EVM Import, SVM Wallet, Pairing Message 0';
                    signature = void 0;
                    if (!litCachedMinSig) return [3 /*break*/, 2];
                    signature = litCachedMinSig;
                    return [3 /*break*/, 4];
                case 2:
                    signEcdsa = "(async() => {\n        const sigShare = await LitActions.signEcdsa({ toSign, publicKey, sigName });\n      })();";
                    return [4 /*yield*/, litNodeClient.pkpSign({
                            pubKey: PKP.publicKey,
                            sessionSigs: litSession,
                            toSign: prepMessage(messageToVerify_0),
                        })];
                case 3:
                    signResponse = _c.sent();
                    signature = signResponse === null || signResponse === void 0 ? void 0 : signResponse.signature;
                    //save signature to local storage
                    setLitCachedMinSig(signature);
                    _c.label = 4;
                case 4:
                    console.log('WUJI, time to get cache call signature', Date.now() - startTime);
                    return [2 /*return*/, signature];
                case 5:
                    e_1 = _c.sent();
                    console.log('WUJI Error in signatureToDecryptEncryptedWallet: ', e_1);
                    return [4 /*yield*/, slackLogger({
                            type: 'DECRYPT ERROR',
                            pkp: PKP,
                            payload: {
                                error: JSON.stringify(e_1),
                            },
                        })];
                case 6:
                    _c.sent();
                    return [2 /*return*/, {
                            error: e_1,
                        }];
                case 7: return [2 /*return*/];
            }
        });
    });
}
export function decryptEncryptedWallet(_a) {
    return __awaiter(this, arguments, void 0, function (_b) {
        var code, encryptionSig, resp, privateKey, encryptedEVMKey, respArray, solanaKeyPair, encryptedSolanaKey, e_2;
        var _c;
        var PKP = _b.PKP, litSession = _b.litSession, litNodeClient = _b.litNodeClient, encryptedWallet = _b.encryptedWallet, signature = _b.signature, setCipher1 = _b.setCipher1, setCipher2 = _b.setCipher2;
        return __generator(this, function (_d) {
            switch (_d.label) {
                case 0:
                    _d.trys.push([0, 3, , 5]);
                    return [4 /*yield*/, fetchIPFSData('Qmdn3AEqUf3WfS4L5XLdAtqm8eDvkLvHRDZJYfEW9vdTzf')];
                case 1:
                    code = _d.sent();
                    encryptionSig = signature === null || signature === void 0 ? void 0 : signature.slice(3, 35);
                    return [4 /*yield*/, litNodeClient.executeJs({
                            code: code,
                            sessionSigs: litSession,
                            jsParams: {
                                ipfsHash: 'Qmdn3AEqUf3WfS4L5XLdAtqm8eDvkLvHRDZJYfEW9vdTzf',
                                signature: signature,
                                ethAddress: PKP === null || PKP === void 0 ? void 0 : PKP.ethAddress,
                                encrypt: false,
                                ciphertext: encryptedWallet.ciphertext,
                                dataToEncryptHash: encryptedWallet.data_to_encrypt_hash,
                                verifyIndex: 0,
                            },
                        })];
                case 2:
                    resp = _d.sent();
                    if (!(resp === null || resp === void 0 ? void 0 : resp.response)) {
                        throw new Error("decryptEncryptedWallet Error in decrypting the wallet. No response from Lit. Response: ".concat(JSON.stringify(resp)));
                    }
                    if (encryptedWallet.type === 'EVM') {
                        privateKey = resp === null || resp === void 0 ? void 0 : resp.response;
                        encryptedEVMKey = encrypt(privateKey, encryptionSig);
                        setCipher1(encryptedEVMKey);
                        return [2 /*return*/, {
                                address: encryptedWallet.address,
                                privateKey: privateKey,
                                wallet: new ethers.Wallet(resp === null || resp === void 0 ? void 0 : resp.response),
                            }];
                    }
                    if (encryptedWallet.type === 'Solana') {
                        respArray = (_c = resp === null || resp === void 0 ? void 0 : resp.response) === null || _c === void 0 ? void 0 : _c.split(',').map(function (x) { return parseInt(x); });
                        solanaKeyPair = Keypair.fromSecretKey(new Uint8Array(respArray));
                        encryptedSolanaKey = encrypt(bs58.encode(solanaKeyPair.secretKey), encryptionSig);
                        setCipher2(encryptedSolanaKey);
                        return [2 /*return*/, {
                                keypair: solanaKeyPair,
                                address: encryptedWallet.address,
                                privateKey: bs58.encode(solanaKeyPair.secretKey),
                            }];
                    }
                    return [3 /*break*/, 5];
                case 3:
                    e_2 = _d.sent();
                    console.log('WUJI Error in decryptEncryptedWallet: ', e_2);
                    return [4 /*yield*/, slackLogger({
                            type: 'DECRYPT ERROR',
                            pkp: PKP,
                            payload: {
                                error: JSON.stringify(e_2),
                                walletType: encryptedWallet.type,
                            },
                        })];
                case 4:
                    _d.sent();
                    return [2 /*return*/, {
                            error: e_2,
                        }];
                case 5: return [2 /*return*/];
            }
        });
    });
}
export var prepMessage = function (message) {
    return ethers.utils.arrayify(ethers.utils.keccak256(ethers.utils.toUtf8Bytes(message)));
};
